//
// Copyright (c) 2020 Astute Global, Inc.
//

define(["marionette", "./template/departmentDetailsTemplate.html"], function (
  Marionette,
  DepartmentDetailsTemplate,
) {
  "use strict";

  var DepartmentDetailsView = {};

  DepartmentDetailsView.departmentDetailsLayout = Marionette.Layout.extend({
    template: DepartmentDetailsTemplate,
    regions: {
      basicDepartmentInfo: "#basicDepartmentInfoDiv",
      kbAndLocaleSelect: "#kbAndLocaleSelectDiv",
      users: "#usersDiv",
    },
    triggers: {
      "click #deleteDepartment": "delete:department",
    },
  });

  return DepartmentDetailsView;
});
